import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_328: DocMigration = {
  maxSchemaVersion: "0.0.328",
  description: "set eaveCutType to undefined if not PLUMB or SQUARED",
  apply(json: any) {
    for (const settingsId in json.settings) {
      const setting = json.settings[settingsId];

      if (setting.type === "ROOF_SETTINGS") {
        const { eaveCutType } = setting;
        if (eaveCutType !== "PLUMB" && eaveCutType !== "SQUARED" && eaveCutType !== undefined) {
          delete setting.eaveCutType;
        }
      }
    }

    for (const roofId in json.roofs) {
      const { roofSettings } = json.roofs[roofId];
      if (!roofSettings) {
        continue;
      }
      const { eaveCutType } = roofSettings;
      if (eaveCutType !== "PLUMB" && eaveCutType !== "SQUARED" && eaveCutType !== undefined) {
        delete roofSettings.eaveCutType;
      }
    }

    return json;
  },
};

export default migration_0_0_328;
